import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Pending from "@/pages/Pending";
import AdminPanel from "@/pages/AdminPanel";
import Studio from "@/pages/Studio";
import Team from "@/pages/Team";
import Analytics from "@/pages/Analytics";
import Demo from "@/pages/Demo";
import Docs from "@/pages/Docs";
import AppShell from "@/components/AppShell";
import { isAuthed, getUser } from "@/lib/api";

function Protected({ children, need }) {
  const user = getUser();
  if (!isAuthed() || !user) return <Navigate to="/login" replace />;
  if (need === "admin" && user.role !== "platform_admin") return <Navigate to="/" replace />;
  if (user.role !== "platform_admin" && user.companyStatus !== "approved") return <Navigate to="/pending" replace />;
  return <AppShell>{children}</AppShell>;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/pending" element={<Pending />} />
      <Route path="/demo/:id" element={<Demo />} />
      <Route path="/admin" element={<Protected need="admin"><AdminPanel /></Protected>} />
      <Route path="/" element={<Protected><Studio /></Protected>} />
      <Route path="/team" element={<Protected><Team /></Protected>} />
      <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
      <Route path="/docs" element={<Protected><Docs /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
